var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1588,
    height: 1353,
    viewBox: "0 0 1588 1353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1004_796)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 22.5,
    x2: 1587.78,
    y2: 22.5,
    stroke: "url(#paint0_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.9785,
    y1: 23,
    x2: 26.9785,
    y2: 1353,
    stroke: "url(#paint1_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.8047,
    y1: 23,
    x2: 84.8046,
    y2: 1353,
    stroke: "url(#paint2_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.631,
    y1: 23,
    x2: 142.631,
    y2: 1353,
    stroke: "url(#paint3_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.456,
    y1: 23,
    x2: 200.456,
    y2: 1353,
    stroke: "url(#paint4_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.282,
    y1: 23,
    x2: 258.282,
    y2: 1353,
    stroke: "url(#paint5_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.108,
    y1: 23,
    x2: 316.108,
    y2: 1353,
    stroke: "url(#paint6_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373.935,
    y1: 23,
    x2: 373.935,
    y2: 1353,
    stroke: "url(#paint7_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.761,
    y1: 23,
    x2: 431.761,
    y2: 1353,
    stroke: "url(#paint8_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.587,
    y1: 23,
    x2: 489.587,
    y2: 1353,
    stroke: "url(#paint9_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 547.413,
    y1: 23,
    x2: 547.413,
    y2: 1353,
    stroke: "url(#paint10_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 605.239,
    y1: 23,
    x2: 605.239,
    y2: 1353,
    stroke: "url(#paint11_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 663.065,
    y1: 23,
    x2: 663.065,
    y2: 1353,
    stroke: "url(#paint12_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720.892,
    y1: 23,
    x2: 720.892,
    y2: 1353,
    stroke: "url(#paint13_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 778.718,
    y1: 23,
    x2: 778.718,
    y2: 1353,
    stroke: "url(#paint14_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 836.544,
    y1: 23,
    x2: 836.544,
    y2: 1353,
    stroke: "url(#paint15_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 894.37,
    y1: 23,
    x2: 894.37,
    y2: 1353,
    stroke: "url(#paint16_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 952.195,
    y1: 23,
    x2: 952.195,
    y2: 1353,
    stroke: "url(#paint17_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1010.02,
    y1: 23,
    x2: 1010.02,
    y2: 1353,
    stroke: "url(#paint18_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1067.85,
    y1: 23,
    x2: 1067.85,
    y2: 1353,
    stroke: "url(#paint19_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1125.67,
    y1: 23,
    x2: 1125.67,
    y2: 1353,
    stroke: "url(#paint20_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1183.5,
    y1: 23,
    x2: 1183.5,
    y2: 1353,
    stroke: "url(#paint21_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1241.33,
    y1: 23,
    x2: 1241.33,
    y2: 1353,
    stroke: "url(#paint22_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1299.15,
    y1: 23,
    x2: 1299.15,
    y2: 1353,
    stroke: "url(#paint23_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1356.98,
    y1: 23,
    x2: 1356.98,
    y2: 1353,
    stroke: "url(#paint24_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1414.8,
    y1: 23,
    x2: 1414.8,
    y2: 1353,
    stroke: "url(#paint25_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1472.63,
    y1: 23,
    x2: 1472.63,
    y2: 1353,
    stroke: "url(#paint26_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1530.46,
    y1: 23,
    x2: 1530.46,
    y2: 1353,
    stroke: "url(#paint27_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 80.3262,
    x2: 1587.78,
    y2: 80.3262,
    stroke: "url(#paint28_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 138.152,
    x2: 1587.78,
    y2: 138.152,
    stroke: "url(#paint29_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 195.978,
    x2: 1587.78,
    y2: 195.978,
    stroke: "url(#paint30_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 253.804,
    x2: 1587.78,
    y2: 253.804,
    stroke: "url(#paint31_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 311.63,
    x2: 1587.78,
    y2: 311.63,
    stroke: "url(#paint32_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 369.457,
    x2: 1587.78,
    y2: 369.457,
    stroke: "url(#paint33_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 427.283,
    x2: 1587.78,
    y2: 427.283,
    stroke: "url(#paint34_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 485.109,
    x2: 1587.78,
    y2: 485.109,
    stroke: "url(#paint35_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 542.935,
    x2: 1587.78,
    y2: 542.935,
    stroke: "url(#paint36_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 600.761,
    x2: 1587.78,
    y2: 600.761,
    stroke: "url(#paint37_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 658.587,
    x2: 1587.78,
    y2: 658.587,
    stroke: "url(#paint38_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 716.413,
    x2: 1587.78,
    y2: 716.413,
    stroke: "url(#paint39_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 774.239,
    x2: 1587.78,
    y2: 774.239,
    stroke: "url(#paint40_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 832.065,
    x2: 1587.78,
    y2: 832.065,
    stroke: "url(#paint41_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 889.891,
    x2: 1587.78,
    y2: 889.891,
    stroke: "url(#paint42_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 947.717,
    x2: 1587.78,
    y2: 947.717,
    stroke: "url(#paint43_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 1005.54,
    x2: 1587.78,
    y2: 1005.54,
    stroke: "url(#paint44_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 1063.37,
    x2: 1587.78,
    y2: 1063.37,
    stroke: "url(#paint45_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 1121.2,
    x2: 1587.78,
    y2: 1121.2,
    stroke: "url(#paint46_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 1179.02,
    x2: 1587.78,
    y2: 1179.02,
    stroke: "url(#paint47_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 1236.85,
    x2: 1587.78,
    y2: 1236.85,
    stroke: "url(#paint48_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 1294.67,
    x2: 1587.78,
    y2: 1294.67,
    stroke: "url(#paint49_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147,
    y1: 1352.5,
    x2: 1587.78,
    y2: 1352.5,
    stroke: "url(#paint50_linear_1004_796)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1004_796)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.366,
    y: 195,
    width: 162.82,
    height: 387.976,
    rx: 81.4098,
    transform: "rotate(30.7495 142.366 195)",
    fill: "#8151BD"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1004_796)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491,
    y: 717,
    width: 606,
    height: 289,
    rx: 144.5,
    fill: "#5280A7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1004_796)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1472.35,
    y: 211,
    width: 100.197,
    height: 397.745,
    rx: 50.0984,
    transform: "rotate(11.3608 1472.35 211)",
    fill: "#3A3D9A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1004_796",
    x: -229.835,
    y: 21.1658,
    width: 685.965,
    height: 764.347,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 102,
    result: "effect1_foregroundBlur_1004_796"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1004_796",
    x: 197,
    y: 423,
    width: 1194,
    height: 877,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 147,
    result: "effect1_foregroundBlur_1004_796"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1004_796",
    x: 1138.88,
    y: -44.1226,
    width: 686.829,
    height: 919.935,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 132,
    result: "effect1_foregroundBlur_1004_796"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1004_796",
    x1: 720.391,
    y1: 23,
    x2: 720.391,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1004_796",
    x1: 26.4785,
    y1: 688,
    x2: 25.4785,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1004_796",
    x1: 84.3047,
    y1: 688,
    x2: 83.3047,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1004_796",
    x1: 142.131,
    y1: 688,
    x2: 141.131,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1004_796",
    x1: 199.956,
    y1: 688,
    x2: 198.956,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1004_796",
    x1: 257.782,
    y1: 688,
    x2: 256.782,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1004_796",
    x1: 315.608,
    y1: 688,
    x2: 314.608,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1004_796",
    x1: 373.435,
    y1: 688,
    x2: 372.435,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1004_796",
    x1: 431.261,
    y1: 688,
    x2: 430.261,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1004_796",
    x1: 489.087,
    y1: 688,
    x2: 488.087,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1004_796",
    x1: 546.913,
    y1: 688,
    x2: 545.913,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1004_796",
    x1: 604.739,
    y1: 688,
    x2: 603.739,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1004_796",
    x1: 662.565,
    y1: 688,
    x2: 661.565,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1004_796",
    x1: 720.392,
    y1: 688,
    x2: 719.392,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1004_796",
    x1: 778.218,
    y1: 688,
    x2: 777.218,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1004_796",
    x1: 836.044,
    y1: 688,
    x2: 835.044,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1004_796",
    x1: 893.87,
    y1: 688,
    x2: 892.87,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1004_796",
    x1: 951.695,
    y1: 688,
    x2: 950.695,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1004_796",
    x1: 1009.52,
    y1: 688,
    x2: 1008.52,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1004_796",
    x1: 1067.35,
    y1: 688,
    x2: 1066.35,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1004_796",
    x1: 1125.17,
    y1: 688,
    x2: 1124.17,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1004_796",
    x1: 1183,
    y1: 688,
    x2: 1182,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1004_796",
    x1: 1240.83,
    y1: 688,
    x2: 1239.83,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1004_796",
    x1: 1298.65,
    y1: 688,
    x2: 1297.65,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1004_796",
    x1: 1356.48,
    y1: 688,
    x2: 1355.48,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1004_796",
    x1: 1414.3,
    y1: 688,
    x2: 1413.3,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1004_796",
    x1: 1472.13,
    y1: 688,
    x2: 1471.13,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1004_796",
    x1: 1529.96,
    y1: 688,
    x2: 1528.96,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1004_796",
    x1: 720.391,
    y1: 80.8262,
    x2: 720.391,
    y2: 81.8262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1004_796",
    x1: 720.391,
    y1: 138.652,
    x2: 720.391,
    y2: 139.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1004_796",
    x1: 720.391,
    y1: 196.478,
    x2: 720.391,
    y2: 197.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1004_796",
    x1: 720.391,
    y1: 254.304,
    x2: 720.391,
    y2: 255.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1004_796",
    x1: 720.391,
    y1: 312.13,
    x2: 720.391,
    y2: 313.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1004_796",
    x1: 720.391,
    y1: 369.957,
    x2: 720.391,
    y2: 370.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1004_796",
    x1: 720.391,
    y1: 427.783,
    x2: 720.391,
    y2: 428.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1004_796",
    x1: 720.391,
    y1: 485.609,
    x2: 720.391,
    y2: 486.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1004_796",
    x1: 720.391,
    y1: 543.435,
    x2: 720.391,
    y2: 544.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1004_796",
    x1: 720.391,
    y1: 601.261,
    x2: 720.391,
    y2: 602.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1004_796",
    x1: 720.391,
    y1: 659.087,
    x2: 720.391,
    y2: 660.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1004_796",
    x1: 720.391,
    y1: 716.913,
    x2: 720.391,
    y2: 717.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1004_796",
    x1: 720.391,
    y1: 774.739,
    x2: 720.391,
    y2: 775.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1004_796",
    x1: 720.391,
    y1: 832.565,
    x2: 720.391,
    y2: 833.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1004_796",
    x1: 720.391,
    y1: 890.391,
    x2: 720.391,
    y2: 891.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1004_796",
    x1: 720.391,
    y1: 948.217,
    x2: 720.391,
    y2: 949.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1004_796",
    x1: 720.391,
    y1: 1006.04,
    x2: 720.391,
    y2: 1007.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1004_796",
    x1: 720.391,
    y1: 1063.87,
    x2: 720.391,
    y2: 1064.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1004_796",
    x1: 720.391,
    y1: 1121.7,
    x2: 720.391,
    y2: 1122.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1004_796",
    x1: 720.391,
    y1: 1179.52,
    x2: 720.391,
    y2: 1180.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1004_796",
    x1: 720.391,
    y1: 1237.35,
    x2: 720.391,
    y2: 1238.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1004_796",
    x1: 720.391,
    y1: 1295.17,
    x2: 720.391,
    y2: 1296.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1004_796",
    x1: 720.391,
    y1: 1353,
    x2: 720.391,
    y2: 1354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D1D1D110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D110"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1004_796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1588,
    height: 1353,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.31969f1a5f525ec71a54181436e87658.svg";
export { ForwardRef as ReactComponent };